import React, { Suspense, lazy } from 'react';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';

// 使用 React.lazy 懒加载组件
const TouristMap = lazy(() => import('./components/TouristMap'));

/**
 * 加载中组件
 */
const LoadingFallback = () => (
  <div className="loading-container">
    <div className="loading-spinner"></div>
    <p>加载中，请稍候...</p>
  </div>
);

/**
 * 应用主组件
 */
function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <Suspense fallback={<LoadingFallback />}>
      <main>
        <TouristMap />
      </main>
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}

export default App;
